import React from 'react';
import { View, Platform, ScrollView } from 'react-native';
import { router } from 'expo-router';
import { Text, TouchableRipple, Button } from 'react-native-paper';
import RBSheet from "react-native-raw-bottom-sheet";
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { MoreCircle, More, TickCircle, Edit, CloseCircle } from 'iconsax-react-native';

export default function CustomerCard({ data, isMy = false }){
  const refRBSheet = React.useRef();
  const insets = useSafeAreaInsets();

  const handlePresentModalPress = React.useCallback(() => {
    refRBSheet.current.open();
  }, []);

  return (
    <>
      <View style={{ flex: 1, backgroundColor: '#fff', elevation: 2, borderRadius: 8, padding: 12, marginBottom: 8 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          {
            data.class === 'confirm-add' ?
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <TickCircle size="24" color="#3C9A4F" variant="Bold"/>
                <Text dir="rtl" style={{ fontSize: 12, marginStart: 8, color: '#3C9A4F' }}>تایید شده</Text>
              </View>
            :
              data.class === 'waiting-confirm' ?
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <MoreCircle size="24" color="#FFA200" variant="Bold"/>
                  <Text dir="rtl" style={{ fontSize: 12, marginStart: 8, color: '#FFA200' }}>در انتظار بررسی!</Text>
                </View>
                :
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <CloseCircle size="24" color="#D61600" variant="Bold"/>
                  <Text dir="rtl" style={{ fontSize: 12, marginStart: 8, color: '#D61600' }}>رد شده</Text>
                </View>
          }
          {(isMy) && <TouchableRipple borderless onPress={handlePresentModalPress} style={{ width: 30, height: 30, alignItems: 'center', justifyContent: 'center', borderRadius: 30, marginRight: -5 }}><More size="20" style={{ transform: [{rotate: '45deg'}, {rotateZ: '0.785398rad'}] }} color="#5B5E63" variant="Outline"/></TouchableRipple>}
        </View> 
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', paddingTop: 8 }}>
          {
            isMy &&
              <>
                <View style={{ width: '100%', flexDirection: 'row', marginBottom: 8 }}>
                  <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>نام مشتری: </Text>
                  <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.user?.name}</Text>
                </View>
                <View style={{ width: '100%', flexDirection: 'row', marginBottom: 8 }}>
                  <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>شماره مشتری: </Text>
                  <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.user?.mobile}</Text>
                </View>
              </>
          }
          <View style={{ width: '100%', flexDirection: 'row', marginBottom: 8 }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>کد مشتری: </Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.crmId}</Text>
          </View>
          <View style={{ width: '100%', flexDirection: 'row', marginBottom: 8 }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>منطقه: </Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.region?.mantaghe}</Text>
          </View>
          <View style={{ width: '100%', flexDirection: 'row' }}>
            <Text style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>کارشناس: </Text>
            {
              data.expert && Object.keys(data.expert).length > 0 &&
                Object.values(data.expert).map((item, i) => (
                  <Text dir="rtl" key={i} style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{item.name}{Object.keys(data.expert).length !== (i+1) ? ', ' : ''}</Text>
                ))
            }
          </View>
        </View>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', borderTopWidth: 1, borderTopColor: '#EBEBEB', marginTop: 8, paddingTop: 8 }}>
          <View style={{ width: '50%', marginBottom: 8 }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>نوع معامله:</Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.transactions?.term_name}</Text>
          </View>
          <View style={{ width: '50%', marginBottom: 8 }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>نوع ملک:</Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.land_types?.term_name}</Text>
          </View>
          <View style={{ width: '50%' }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>قیمت درخواستی:</Text>
            {
              data.price && Object.keys(data.price).length > 0 &&
                Object.values(data.price).map((item, i) => (
                  <View key={i}>
                    <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{item.from.replace(/<[^>]*>?/gm, '')}</Text>
                    <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{item.to.replace(/<[^>]*>?/gm, '')}</Text>
                  </View>
                ))
            }
          </View>
          <View style={{ width: '50%' }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>متراژ درخواستی:</Text>
            {
              data.area && Object.keys(data.area).length > 0 &&
                Object.values(data.area).map((item, i) => (
                  <View key={i}>
                    <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{item.from.replace(/<[^>]*>?/gm, '')}</Text>
                    <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{item.to.replace(/<[^>]*>?/gm, '')}</Text>
                  </View>
                ))
            }
          </View>
        </View>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', borderTopWidth: 1, borderTopColor: '#EBEBEB', marginTop: 8, paddingTop: 8 }}>
          <View style={{ width: '50%' }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>تاریخ ثبت:</Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.created_at}</Text>
          </View>
          <View style={{ width: '50%' }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>تاریخ بروزرسانی:</Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.updated_at}</Text>
          </View>
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
          <Button labelStyle={{ fontSize: 16, fontFamily: 'IRANSans_Medium' }} style={{ width: isMy ? '80%' : '100%', borderRadius: 48, backgroundColor: '#2B93F3' }}  mode="contained" onPress={() => alert('این بخش فعلا راهندازی نشده است')}>نمایش</Button>
          {isMy && <TouchableRipple borderless onPress={() => router.push(`customer/${data.id}`)} style={{ width: 48, height: 48, alignItems: 'center', justifyContent: 'center', borderRadius: 30 }}><Edit size="28" color="#292D32" variant="Outline"/></TouchableRipple>}
        </View>
      </View>
      <RBSheet
        ref={refRBSheet}
        closeOnDragDown={true}
        closeOnPressMask={true}
        height={170}
        customStyles={{
          container: {
            paddingBottom: insets.bottom
          },
          wrapper: {
            backgroundColor: "rgba(0, 0, 0, 0.3)"
          },
          draggableIcon: {
            backgroundColor: "#555"
          }
        }}
      >
        <ScrollView contentContainerStyle={{ paddingHorizontal: 20, paddingVertical: 8 }}>
          <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', marginBottom: 10, textAlign: 'center' }}>نام مشتری: {data.user?.name}</Text>
          <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={() => router.push(`relatedAds/${data.id}`)} style={{ width: '100%', height: 48, paddingHorizontal: 12, justifyContent: 'center', borderBottomColor: '#BFC0C5', borderBottomWidth: 1 }}>
            <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>آگهی‌های پیشنهادی</Text>
          </TouchableRipple>
        </ScrollView>
      </RBSheet>
    </>
  );
};